import { Textfield } from '@src/shared/fields/text-field';
import { Label } from '@src/design-system/label';
import { FormikCountryField } from '@src/shared/fields/country-field/formik-country-field';
import { Location } from 'iconsax-react';
import type { FC } from 'react';

const UniversityAddress: FC = () => {
    return (
        <div className='space-y-4 border border-gray-200 rounded-[12px] p-4'>
            <div className='flex items-center gap-2'>
                <Location className='text-gray-900' size={24} />
                <p className='text-gray-900 font-medium'>Address</p>
            </div>
            <div className='grid grid-cols-2 gap-4'>
                <Textfield
                    name='address_line_1'
                    label='Address 1'
                    placeholder='Enter Address 1'
                />
                <Textfield
                    name='address_line_2'
                    label='Address 2'
                    placeholder='Enter Address 2'
                />
                <Textfield
                    name='city'
                    label='City'
                    placeholder='Enter City'
                />
                <Textfield
                    name='state'
                    label='State/ Province'
                    placeholder='Enter State'
                />
                <Textfield
                    name='postal_code'
                    label='Zip Code'
                    placeholder='Enter Zip Code'
                />
                <div>
                    <Label className='mb-2'>Country</Label>
                    <FormikCountryField
                        selectName='country'
                        isInModal
                    />
                </div>
            </div>
        </div>
    );
};

export default UniversityAddress;
